import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "tw-text-sm tw-text-slate-600"
}
const _hoisted_2 = {
  key: 1,
  class: "tw-text-left"
}
const _hoisted_3 = { class: "tw-mt-3 tw-border-b tw-border-slate-200" }
const _hoisted_4 = { class: "tw-flex tw-flex-wrap tw-gap-2 tw-pb-3" }
const _hoisted_5 = {
  key: 0,
  class: "tw-inline-flex tw-items-center tw-rounded-full tw-bg-emerald-600 tw-ml-2 tw-px-2.5 tw-py-1 tw-text-xs tw-font-semibold tw-text-white"
}
const _hoisted_6 = { class: "tw-mt-4" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 0,
  class: "tw-flex tw-justify-center tw-py-10"
}
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 2 }
const _hoisted_11 = { key: 3 }
const _hoisted_12 = { key: 4 }
const _hoisted_13 = { key: 5 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ContainerTripsTable = _resolveComponent("ContainerTripsTable")!
  const _component_ContainerTerminalEventsTable = _resolveComponent("ContainerTerminalEventsTable")!
  const _component_AddNotesArea = _resolveComponent("AddNotesArea")!
  const _component_ContainerReeferDetails = _resolveComponent("ContainerReeferDetails")!
  const _component_ContainerPayableArea = _resolveComponent("ContainerPayableArea")!
  const _component_ContainerReceivableArea = _resolveComponent("ContainerReceivableArea")!
  const _component_VesselFinderEmbed = _resolveComponent("VesselFinderEmbed")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.$apollo.queries.container.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, "Loading..."))
      : (_ctx.container)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("nav", _hoisted_4, [
                _createElementVNode("button", {
                  type: "button",
                  class: _normalizeClass(["tw-inline-flex tw-items-center tw-rounded-lg tw-border tw-px-3 tw-py-1.5 tw-text-xs tw-font-semibold tw-transition-colors", _ctx.activeTab === 'trips' ? 'tw-border-slate-900 tw-bg-slate-900 tw-text-white' : 'tw-border-slate-200 tw-bg-gray-100 tw-text-slate-700 hover:tw-bg-slate-50']),
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.activeTab = 'trips'))
                }, " Trips ", 2),
                (_ctx.shouldShowYardStatus)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: _normalizeClass(["tw-inline-flex tw-items-center tw-rounded-lg tw-border tw-px-3 tw-py-1.5 tw-text-xs tw-font-semibold tw-transition-colors", _ctx.activeTab === 'terminal' ? 'tw-border-slate-900 tw-bg-slate-900 tw-text-white' : 'tw-border-slate-200 tw-bg-gray-100 tw-text-slate-700 hover:tw-bg-slate-50']),
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.activeTab = 'terminal'))
                    }, " Terminal Status ", 2))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  type: "button",
                  class: _normalizeClass(["tw-inline-flex tw-items-center tw-rounded-lg tw-border tw-px-3 tw-py-1.5 tw-text-xs tw-font-semibold tw-transition-colors", _ctx.activeTab === 'notes'
              ? (_ctx.container?.notes?.length > 0
                ? 'tw-border-emerald-700 tw-bg-emerald-700 tw-text-white'
                : 'tw-border-slate-900 tw-bg-slate-900 tw-text-white')
              : (_ctx.container?.notes?.length > 0
                ? 'tw-border-emerald-300 tw-bg-emerald-50 tw-text-emerald-700 hover:tw-bg-emerald-100'
                : 'tw-border-slate-200 tw-bg-gray-100 tw-text-slate-700 hover:tw-bg-slate-50')]),
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.activeTab = 'notes'))
                }, [
                  _cache[8] || (_cache[8] = _createTextVNode(" Container Notes ", -1)),
                  (_ctx.container?.notes?.length > 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.container.notes.length), 1))
                    : _createCommentVNode("", true)
                ], 2),
                (_ctx.isReefer)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      type: "button",
                      class: _normalizeClass(["tw-inline-flex tw-items-center tw-rounded-lg tw-border tw-px-3 tw-py-1.5 tw-text-xs tw-font-semibold tw-transition-colors", _ctx.activeTab === 'reefer' ? 'tw-border-slate-900 tw-bg-slate-900 tw-text-white' : 'tw-border-slate-200 tw-bg-gray-100 tw-text-slate-700 hover:tw-bg-slate-50']),
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.activeTab = 'reefer'))
                    }, " Reefer ", 2))
                  : _createCommentVNode("", true),
                (_ctx.container && _ctx.container.vessel && _ctx.container.vessel.mssi)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 2,
                      type: "button",
                      class: _normalizeClass(["tw-inline-flex tw-items-center tw-rounded-lg tw-border tw-px-3 tw-py-1.5 tw-text-xs tw-font-semibold tw-transition-colors", _ctx.isVesselTrackingModalOpen ? 'tw-border-slate-900 tw-bg-slate-900 tw-text-white' : 'tw-border-slate-200 tw-bg-gray-100 tw-text-slate-700 hover:tw-bg-slate-50']),
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isVesselTrackingModalOpen = !_ctx.isVesselTrackingModalOpen))
                    }, " Vessel Tracking ", 2))
                  : _createCommentVNode("", true),
                (!_ctx.showingExternally)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 3,
                      type: "button",
                      class: _normalizeClass(["tw-inline-flex tw-items-center tw-rounded-lg tw-border tw-px-3 tw-py-1.5 tw-text-xs tw-font-semibold tw-transition-colors", _ctx.activeTab === 'payable' ? 'tw-border-slate-900 tw-bg-slate-900 tw-text-white' : 'tw-border-slate-200 tw-bg-gray-100 tw-text-slate-700 hover:tw-bg-slate-50']),
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.activeTab = 'payable'))
                    }, " Payable ", 2))
                  : _createCommentVNode("", true),
                (!_ctx.showingExternally)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 4,
                      type: "button",
                      class: _normalizeClass(["tw-inline-flex tw-items-center tw-rounded-lg tw-border tw-px-3 tw-py-1.5 tw-text-xs tw-font-semibold tw-transition-colors", _ctx.activeTab === 'receivable' ? 'tw-border-slate-900 tw-bg-slate-900 tw-text-white' : 'tw-border-slate-200 tw-bg-gray-100 tw-text-slate-700 hover:tw-bg-slate-50']),
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.activeTab = 'receivable'))
                    }, " Receivable ", 2))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              (_ctx.activeTab === 'trips')
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    (_ctx.addTripLoading)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [...(_cache[9] || (_cache[9] = [
                          _createElementVNode("div", { class: "tw-h-8 tw-w-8 tw-animate-spin tw-rounded-full tw-border-2 tw-border-slate-300 tw-border-t-slate-600" }, null, -1)
                        ]))]))
                      : (_openBlock(), _createBlock(_component_ContainerTripsTable, {
                          caller: "orders",
                          showDriver: _ctx.showDriver,
                          editable: _ctx.editable && !_ctx.container.isCancelled,
                          key: _ctx.container.id,
                          order: _ctx.order,
                          container: _ctx.container,
                          trips: _ctx.container.trips,
                          drivers: _ctx.drivers,
                          chassis: _ctx.chassis,
                          onRefreshOrders: _ctx.refreshOrders
                        }, null, 8, ["showDriver", "editable", "order", "container", "trips", "drivers", "chassis", "onRefreshOrders"]))
                  ]))
                : (_ctx.activeTab === 'terminal' && _ctx.shouldShowYardStatus)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      (_ctx.containerEvents)
                        ? (_openBlock(), _createBlock(_component_ContainerTerminalEventsTable, {
                            key: 0,
                            containerEvents: _ctx.containerEvents,
                            terminal: _ctx.container.dischargeTerminal
                          }, null, 8, ["containerEvents", "terminal"]))
                        : _createCommentVNode("", true)
                    ]))
                  : (_ctx.activeTab === 'notes')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createVNode(_component_AddNotesArea, {
                          onAddedNote: _ctx.updateContainer,
                          notes: _ctx.container.notes,
                          archivedNotes: _ctx.container.archivedNotes,
                          container: _ctx.container
                        }, null, 8, ["onAddedNote", "notes", "archivedNotes", "container"])
                      ]))
                    : (_ctx.activeTab === 'reefer' && _ctx.isReefer)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          _createVNode(_component_ContainerReeferDetails, {
                            container: _ctx.container,
                            editable: _ctx.editable && !_ctx.container.isCancelled
                          }, null, 8, ["container", "editable"])
                        ]))
                      : (_ctx.activeTab === 'payable' && !_ctx.showingExternally)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                            _createVNode(_component_ContainerPayableArea, { container: _ctx.container }, null, 8, ["container"])
                          ]))
                        : (_ctx.activeTab === 'receivable' && !_ctx.showingExternally)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                              _createVNode(_component_ContainerReceivableArea, {
                                containerId: _ctx.container.id
                              }, null, 8, ["containerId"])
                            ]))
                          : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
    (_ctx.container && _ctx.container.vessel && _ctx.container.vessel.mssi)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 2,
          isOpen: _ctx.isVesselTrackingModalOpen,
          "onUpdate:isOpen": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.isVesselTrackingModalOpen) = $event)),
          modalId: `vessel-tracking-${_ctx.container.containerId}`,
          maxWidth: "4xl"
        }, {
          title: _withCtx(() => [
            _createTextVNode("Vessel Tracking: " + _toDisplayString(_ctx.container.vessel.name) + " (" + _toDisplayString(_ctx.container.vessel.mssi) + ")", 1)
          ]),
          subtitle: _withCtx(() => [...(_cache[10] || (_cache[10] = []))]),
          content: _withCtx(() => [
            _createVNode(_component_VesselFinderEmbed, {
              mssi: _ctx.container.vessel.mssi,
              height: "500",
              isShowTitle: false
            }, null, 8, ["mssi"])
          ]),
          _: 1
        }, 8, ["isOpen", "modalId"]))
      : _createCommentVNode("", true)
  ]))
}